export const DangerButton = (props) => {
    const {
        children,
        onClick,
        disabled,
        className,
        outlined = false,
        fullWidth = true,
        type = 'button',
    } = props;

    const getButtonClasses = () => {
        if (!outlined) {
            return `bg-red-500 text-white hover:bg-transparent hover:text-red-500`
        } else {
            return `bg-transparent text-red-500 hover:bg-red-500 hover:text-white`
        }
    }

    return (
        <button
            onClick={onClick}
            type={type}
            disabled={disabled}
            className={`rounded-md ${fullWidth ? 'w-full' : ''} border border-solid border-red-500 px-2 py-1 text-sm font-semibold shadow-sm transition-all duration-300 ease-in-out ${getButtonClasses()} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className ?? ''}`}
        >
            {children}
        </button>
    )
}